/**
 * Frontend mirror of the backend branding engine registry. Lists the file
 * extensions the platform can apply branding to today; the detector uses
 * this list to decide whether to inspect uploaded templates for branding
 * tags. Add a new entry here whenever you register a new engine in
 * `functions/src/contentLibrary/branding/`.
 */

export const BRANDABLE_EXTENSIONS = Object.freeze(['docx', 'xlsx', 'pptx'])

/** Human-readable list for admin messaging (keep in sync with BRANDABLE_EXTENSIONS). */
export const SUPPORTED_BRANDING_FORMATS_LABEL = 'DOCX, XLSX and PPTX'

const BRANDABLE_EXTENSIONS_SET = new Set(BRANDABLE_EXTENSIONS)

export function getFileExtension(fileName) {
  if (!fileName) return ''
  const dot = fileName.lastIndexOf('.')
  if (dot < 0) return ''
  return fileName.slice(dot + 1).toLowerCase()
}

export function isBrandableFileName(fileName) {
  return BRANDABLE_EXTENSIONS_SET.has(getFileExtension(fileName))
}

export function getBrandingEngineForFileName(fileName) {
  return isBrandableFileName(fileName) ? getFileExtension(fileName) : null
}
